export default __webpack_public_path__ + "static/media/Headdress of Bedlam.749b1715.jpg";